export class UserAnnouncementRequest {
  userId: string;
  announcementId: string;
}
